"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInterweaveRenderer = exports.STYLE_RESET_CLASSNAME = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const interweave_1 = require("interweave");
exports.STYLE_RESET_CLASSNAME = 'styleReset';
exports.StyledInterweaveRenderer = (0, styled_1.default)(interweave_1.Interweave, {
    shouldForwardProp: (prop) => prop !== 'styleReset'
}) `
  ${({ styleReset, attributes: { id = undefined } = {} }) => styleReset
    ? `
          &${id ? `#${id}` : ''}.${exports.STYLE_RESET_CLASSNAME} * {
            all: ${styleReset};
          }
        `
    : ''};
`;
//# sourceMappingURL=RichTextRenderer.styles.js.map